import { render, staticRenderFns } from "./CompanyJobs.vue?vue&type=template&id=487a06fb&scoped=true&"
import script from "./CompanyJobs.vue?vue&type=script&lang=js&"
export * from "./CompanyJobs.vue?vue&type=script&lang=js&"
import style0 from "./CompanyJobs.vue?vue&type=style&index=0&id=487a06fb&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487a06fb",
  null
  
)

export default component.exports